<div>
	<div *ngIf="isAddOrganization && !isCreateInlineActive">
		<his-plam label="{{'fs.res.common.organizations.external'|hisUi}}" [hisDdKey]="_ddKey" [hisDdContexts]="hisDdContexts">
			<p-autoComplete #content appendTo="body" [dropdown]="true"
                hisLazyDataSource="api/v1/fs/res/researchPartner"
				[forceSelection]="true" field="defaulttext"
				[(ngModel)]="selectedOrganization"
				(onSelect)="onSelect($event.value)">
			</p-autoComplete>
		</his-plam>
		<div class="clearer"></div>
		<button
			*ngIf="showCreateLink && auth.hasAny('RIGHT_CS_PSV_ORGUNIT_CREATE_EXTERNAL_ORGUNIT_MINIMAL', 'RIGHT_CS_PSV_ORGUNIT_CREATE_EXTERNAL_ORGUNIT')"
			(click)="createExternalOrgUnit()"
			hisImage="context_add" class="transparent selectButton indentContent"><span>{{ 'fs.res.common.organizations.external.create' | hisUi }}</span></button>
	</div>

	<div *ngIf="isCreateInlineActive">
		<res-external-organization-create
			[researchPartner]="newResearchPartner">
		</res-external-organization-create>
		<div class="clearer"></div>
		<button (click)="backToSelectExternalOrgaUnit()" hisImage="ARROW_LEFT" class="transparent"><span>{{ 'fs.res.common.organizations.external.action.back' | hisUi }}</span></button>
	</div>

	<ng-container *ngIf="showSelectionBelow">
		<div *ngIf="organizations.length > 0">
			<h3>{{ (organizations.length > 1 ? 'fs.res.common.organizations.external.assignedExternalOrgUnit_plural' : 'fs.res.common.organizations.external.assignedExternalOrgUnit' ) | hisUi }}</h3>
			<p-table [value]="organizations">
				<ng-template pTemplate="header">
					<tr>
						<th>{{ 'fs.res.common.organisations.ResearchPartner.business.defaulttext' | hisUi }}</th>
				   		<th>{{ 'fs.res.common.organizations.ResearchPartner.business.address.city' | hisUi}}</th>
				    	<th>{{'common.actions' | hisUi }}</th>
					</tr>
				</ng-template>
				<ng-template pTemplate="body" let-researchPartner>
					<tr>
				    	<td>{{researchPartner.defaulttext}}</td>
					    <td>
							<span *ngFor="let postAddress of researchPartner.postAddresses">
								{{postAddress.city}}<br/>
							</span>
						</td>
				        <td class="singleLine">
						    <button (click)="deleteOrganization(researchPartner)" hisImage="DELETE" class="icon"
                                title="{{'common.removeAssignmentOf' | hisUi:(researchPartner.defaulttext)}}" [disabled]="readonly">
                            </button>
				        </td>
				    </tr>
				</ng-template>
			</p-table>
		</div>
	</ng-container>
</div>
